module.exports = __webpack_public_path__ + "static/img/cranberry-m.20aec5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/cranberry-m.jpg
// module id = eXTr
// module chunks = 0